// extracted by mini-css-extract-plugin
export default {"button":"QuietHoursComponent_button__NTdLn"};